var map = {
	"./v1.png": 91407,
	"./v2.png": 72500,
	"./v3.png": 93629,
	"./v4.png": 97282,
	"./vip0.png": 67239,
	"./vip1.png": 91454,
	"./vip2.png": 28181,
	"./vip3.png": 16556,
	"./vip4.png": 65955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85095;